import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-non-integrated-solar-financing-lender-logos.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Non-Integrated Lenders";

const NonIntegratedLenders = () => (
  <div className="relative overflow-hidden bg-gradient-to-b from-white to-gray-100">
    <HeroSection title={title} className="flex-col-reverse sm:flex-row">
      <HeroSection.Content className="sm:py-10 sm:pl-14 sm:pr-0 sm:w-1/2 sm:text-left md:pr-10 lg:pr-14">
        <HeroSection.Header className="md:items-start sm:justify-start">
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description>
          Working with credit unions or banks that don’t have APIs yet? Enerflo processes payment calculations for over
          30 financial institutions and programs, so you can still quote effectively in your proposals. More and more
          lenders are understanding the benefits of 3rd party integrations, giving you and your customers more options
          over time.
        </HeroSection.Description>
      </HeroSection.Content>

      <div className="z-[1] p-3 w-full sm:w-1/2 overflow-hidden sm:overflow-visible">
        <figure className="relative sm:mr-[-10vw]">
          <Image
            src={FigureImage}
            alt="Non-integrated solar financing lenders logos."
            layout="responsive"
            quality={100}
            placeholder="blur"
            className="crispImage"
            sizes="(min-width: 768px) 50vw, 100vw"
            lazyBoundary="400px"
          />
        </figure>
      </div>
    </HeroSection>
  </div>
);

export default NonIntegratedLenders;
